import { useContext } from 'react';
import { FlexContext } from '../../../contexts/flexContext';
import { AppContext } from '../../../contexts/appContext';
import { IStructuredSnowplowEvent } from '../../useSnowplowTracker';
import { IWindowEvent } from '../../../utils/windowEvents';
import useNavigation from '../../useNavigation';

export interface IFlexNavigateFinish {
  type: 'finish';
  relaunch: boolean;
  urlToOpen?: string;
  snowplowEvent?: IStructuredSnowplowEvent;
  windowEvent?: IWindowEvent;
}

const useFlexNavigateFinish = () => {
  const { reinitializeApp } = useContext(AppContext);
  const flexContext = useContext(FlexContext);
  const navigation = useNavigation();

  const handleFlexNavigateFinish = (flexNavigate: IFlexNavigateFinish) => {
    // Relaunch the app if instructed.
    if (flexNavigate.relaunch && !flexNavigate.urlToOpen) {
      reinitializeApp();
      return;
    }

    // Outside a FlexContext.Provider (e.g. a flex start's own navigation, which runs inside
    // FlexContextProvider itself), finish is undefined and there is nothing to pop back to.
    // Relaunch with the target if asked, otherwise redirect to it. The redirect relies on
    // redirectToPath's app-link handling, which holds for deep-link entries such as Vitality booking.
    if (!flexContext.finish) {
      if (flexNavigate.relaunch && flexNavigate.urlToOpen) {
        reinitializeApp(flexNavigate.urlToOpen);
      } else if (flexNavigate.urlToOpen) {
        navigation.redirectToPath(flexNavigate.urlToOpen);
      } else {
        reinitializeApp();
      }
      return;
    }

    flexContext.finish(flexNavigate.urlToOpen);
  };

  return handleFlexNavigateFinish;
};

export default useFlexNavigateFinish;
